var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "btn rounded",
      class: { active: _vm.isActive, "btn-light": !_setup.isDarkMode },
      attrs: { type: "button", title: _vm.title, disabled: _vm.isDisabled },
      on: { click: _setup.onClick },
    },
    [
      _vm._t("default", function () {
        return [
          _c("i", {
            class: [
              _vm.iconClass,
              {
                "text-dark":
                  !_vm.isActive && !_vm.isDisabled && !_setup.isDarkMode,
                "text-warning": _vm.isDisabled,
              },
            ],
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }